import { Grid } from '@mui/material';

import React from 'react';

import { ReactComponent as AutoOrManualIcon } from 'common/assets/images/auto-manual.svg';
import { ReactComponent as EffectPeriodIcon } from 'common/assets/images/calendar.svg';
import { ReactComponent as ControlTypeIcon } from 'common/assets/images/control-type.svg';
import { ReactComponent as ControlsCountIcon } from 'common/assets/images/controls.svg';
import { ReactComponent as FrequencyIcon } from 'common/assets/images/frequency.svg';
import { ReactComponent as IndustryTypeIcon } from 'common/assets/images/industryicon.svg';
import { ReactComponent as KeyControlIcon } from 'common/assets/images/key-control.svg';
import { ReactComponent as OwnerIcon } from 'common/assets/images/owner.svg';
import { ReactComponent as PoliciesCountIcon } from 'common/assets/images/prc-policies-icon.svg';
import { ReactComponent as ProcessCountIcon } from 'common/assets/images/process.svg';
import { ReactComponent as RisksCountIcon } from 'common/assets/images/risks.svg';
import { ReactComponent as NumberIcon } from 'common/assets/images/sharp.svg';

import { getChipInfo } from '../../RiskRefTaxonomyUtils';

import styles from './RiskRefTaxonomyCard.module.scss';

const { chipIconColor } = styles;
// Mapping of icon names to actual icons
const iconMapping: { [key: string]: React.ReactElement } = {
	risk: <RisksCountIcon />,
	control: <ControlsCountIcon />,
	process: <ProcessCountIcon />,
	industryType: <IndustryTypeIcon />,
	frequency: <FrequencyIcon />,
	keyControl: <KeyControlIcon />,
	controlType: <ControlTypeIcon />,
	automatedOrManual: <AutoOrManualIcon />,
	policies: <PoliciesCountIcon fill={chipIconColor} />,
	effectivePeriod: <EffectPeriodIcon />,
	number: <NumberIcon />,
	owner: <OwnerIcon />,
};
const RiskRefTaxonomyIndustryChipView = (props: any) => {
	const { data, className } = props;
	return (
		<Grid
			container
			spacing={1}
			data-testid="industry-chip-view"
			className={className}
		>
			{data?.map(
				(chip: any) =>
					chip?.label &&
					getChipInfo(
						chip?.className || styles['riskref-chip-text'],
						chip?.label,
						iconMapping[chip?.icon],
					),
			)}
		</Grid>
	);
};

export default RiskRefTaxonomyIndustryChipView;
